/* =======================================
   SOULED — Theme JS
   ======================================= */
(function () {
  'use strict';

  var config = window.theme || {};
  var routes = config.routes || {};

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    var str = '';
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      str = Shopify.formatMoney(cents, config.moneyFormat);
    } else {
      str = (cents / 100).toFixed(2);
    }
    return str.replace(/Rs\.?/g, '\u20B9');
  }

  /* ---------- Mobile nav ---------- */
  function initMobileNav() {
    var burger = $('.js-open-mobile-nav');
    var nav = $('#MobileNav');
    var overlay = $('.mobile-nav__overlay');
    if (!burger || !nav) return;
    function close() {
      nav.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }
    burger.addEventListener('click', function () {
      nav.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
    $$('.js-close-mobile-nav').forEach(function (el) { el.addEventListener('click', close); });
    if (overlay) overlay.addEventListener('click', close);
  }

  /* ---------- Search toggle ---------- */
  function initSearch() {
    var btn = $('.js-toggle-search');
    var modal = $('#SearchModal');
    if (!btn || !modal) return;
    btn.addEventListener('click', function () {
      modal.classList.toggle('is-open');
      var input = $('input[type="search"]', modal);
      if (modal.classList.contains('is-open') && input) input.focus();
    });
  }

  /* ---------- Hero slider ---------- */
  function initHeroSliders() {
    $$('.hero-slider').forEach(function (slider) {
      var slides = $$('.hero-slide', slider);
      if (slides.length < 2) return;
      var dotsWrap = $('.hero-dots', slider);
      var current = 0;
      var timer;
      var interval = parseInt(slider.dataset.autoplay, 10) || 5000;

      slides.forEach(function (_, i) {
        if (!dotsWrap) return;
        var dot = document.createElement('button');
        dot.className = 'hero-dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        dot.addEventListener('click', function () { goTo(i); restart(); });
        dotsWrap.appendChild(dot);
      });

      function goTo(i) {
        slides[current].classList.remove('is-active');
        if (dotsWrap) dotsWrap.children[current].classList.remove('is-active');
        current = (i + slides.length) % slides.length;
        slides[current].classList.add('is-active');
        if (dotsWrap) dotsWrap.children[current].classList.add('is-active');
      }
      function restart() {
        clearInterval(timer);
        timer = setInterval(function () { goTo(current + 1); }, interval);
      }
      var prev = $('.hero-arrow--prev', slider);
      var next = $('.hero-arrow--next', slider);
      if (prev) prev.addEventListener('click', function () { goTo(current - 1); restart(); });
      if (next) next.addEventListener('click', function () { goTo(current + 1); restart(); });
      restart();
    });
  }

  /* ---------- Cart drawer ---------- */
  function refreshCartCount(cart) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? 'flex' : 'none';
    });
  }

  function updateDrawer() {
    var drawerBody = $('.cart-drawer__body');
    if (!drawerBody) return Promise.resolve();
    return fetch(routes.cart_url + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('.cart-drawer-body-content');
        var target = drawerBody.querySelector('.cart-drawer-body-content') || drawerBody;
        if (fresh) target.innerHTML = fresh.innerHTML;
      });
  }

  function openCartDrawer() {
    var drawer = $('cart-drawer');
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeCartDrawer() {
    var drawer = $('cart-drawer');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function initCartDrawer() {
    $$('.js-cart-drawer-close').forEach(function (el) { el.addEventListener('click', closeCartDrawer); });
    document.addEventListener('keyup', function (e) { if (e.key === 'Escape') closeCartDrawer(); });
    $$('.js-open-cart-drawer').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        updateDrawer();
        openCartDrawer();
      });
    });
    document.addEventListener('click', function (e) {
      var removeBtn = e.target.closest('[data-drawer-remove]');
      if (removeBtn) {
        e.preventDefault();
        changeLine(removeBtn.getAttribute('data-line'), 0).then(updateDrawer);
      }
    });
  }

  function changeLine(line, quantity) {
    return fetch(routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (r) { return r.json(); });
  }

  /* ---------- AJAX add to cart forms ---------- */
  function initAddToCartForms() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[action*="/cart/add"]');
      if (!form) return;
      e.preventDefault();
      var button = form.querySelector('[type="submit"]');
      var originalLabel = button ? button.innerHTML : '';
      if (button) { button.disabled = true; button.innerHTML = 'Adding…'; }

      fetch(routes.cart_add_url + '.js', { method: 'POST', body: new FormData(form) })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status && data.status !== 200) throw data;
          return fetch(routes.cart_url + '.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          refreshCartCount(cart);
          return updateDrawer();
        })
        .then(openCartDrawer)
        .catch(function (err) {
          alert(err.description || err.message || 'Could not add to cart.');
        })
        .finally(function () {
          if (button) { button.disabled = false; button.innerHTML = originalLabel; }
        });
    });
  }

  /* ---------- Quantity steppers ---------- */
  function initQuantitySteppers() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qty-change]');
      if (!btn) return;
      var input = btn.parentElement.querySelector('input[type="number"]');
      if (!input) return;
      var val = parseInt(input.value, 10) || 1;
      val += parseInt(btn.getAttribute('data-qty-change'), 10);
      input.value = Math.max(1, val);
      if (input.hasAttribute('data-cart-item')) {
        var form = input.closest('form');
        if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
      }
    });
  }

  /* ---------- Product gallery ---------- */
  function initProductGallery() {
    var gallery = $('[data-product-gallery]');
    if (!gallery) return;
    var mainImg = $('.product-gallery__main img', gallery);
    $$('.product-gallery__thumb', gallery).forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        mainImg.src = thumb.dataset.fullUrl;
        mainImg.srcset = '';
        $$('.product-gallery__thumb', gallery).forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  }

  /* ---------- Variant selection ---------- */
  function initVariantPicker(root) {
    root = root || document;
    $$('[data-variant-picker]', root).forEach(function (picker) {
      var dataEl = $('[type="application/json"][data-variant-json]', picker.closest('.product-info') || picker.parentElement.parentElement);
      if (!dataEl) return;
      var variants = JSON.parse(dataEl.textContent);
      var idInput = picker.querySelector('[data-variant-id-input]');

      function selectedOptions() {
        return $$('input:checked', picker).map(function (i) { return i.value; });
      }
      function matchVariant(options) {
        return variants.find(function (v) {
          return v.options.every(function (o, i) { return o === options[i]; });
        });
      }
      function onChange() {
        var variant = matchVariant(selectedOptions());
        if (!variant) return;
        if (idInput) idInput.value = variant.id;
        var priceEl = $('[data-product-price]', document);
        if (priceEl && variant.price != null) priceEl.textContent = formatMoney(variant.price);
        var compareEl = $('[data-compare-price]', document);
        if (compareEl) {
          compareEl.textContent = variant.compare_at_price && variant.compare_at_price > variant.price ? formatMoney(variant.compare_at_price) : '';
          compareEl.style.display = variant.compare_at_price > variant.price ? '' : 'none';
        }
        var submit = $('[data-atc-button]', document);
        if (submit) {
          submit.disabled = !variant.available;
          submit.textContent = variant.available ? config.strings.addToCart : config.strings.soldOut;
        }
        var stickyInput = $('[data-sticky-variant-input]');
        if (stickyInput) {
          stickyInput.value = variant.id;
          var stickyDataEl = $('[data-sticky-data]');
          if (stickyDataEl && priceEl) {
            try {
              var sd = JSON.parse(stickyDataEl.textContent);
              var sv = sd.variants.find(function (v) { return v.id === variant.id; });
              if (sv) $('[data-sticky-price]').textContent = sv.price;
            } catch (e) { /* noop */ }
          }
          var stickyBtn = stickyInput.parentElement.querySelector('button');
          if (stickyBtn) stickyBtn.disabled = !variant.available;
        }
        if (window.history.replaceState) {
          var url = new URL(window.location);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
      }
      $$('input', picker).forEach(function (i) { i.addEventListener('change', onChange); });
    });
  }

  /* ---------- Collection facets (auto-submit) ---------- */
  function initFacets() {
    var facetsForm = $('#FacetsForm');
    if (!facetsForm) return;
    facetsForm.addEventListener('change', function () {
      if (window.innerWidth >= 990) {
        facetsForm.submit();
      }
    });
    $$('.js-toggle-facets').forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        facetsForm.classList.toggle('is-open');
      });
    });
    $$('.js-close-facets').forEach(function (btn) {
      btn.addEventListener('click', function () {
        facetsForm.classList.remove('is-open');
      });
    });

    // Tab switching for mobile filters
    $$('.facets__tab').forEach(function (tab) {
      tab.addEventListener('click', function () {
        $$('.facets__tab').forEach(function (t) { t.classList.remove('is-active'); });
        $$('.facets__panel').forEach(function (p) { p.classList.remove('is-active'); });
        
        tab.classList.add('is-active');
        var targetId = tab.getAttribute('data-target');
        var panel = document.getElementById(targetId);
        if (panel) panel.classList.add('is-active');
      });
    });
  }

  /* ---------- Sort select ---------- */
  function initSort() {
    $$('[data-sort-select]').forEach(function (sort) {
      sort.addEventListener('change', function () {
        var base = sort.getAttribute('data-sort-base');
        var url = new URL(base || window.location.href, window.location.origin);
        if (sort.value) url.searchParams.set('sort_by', sort.value);
        else url.searchParams.delete('sort_by');
        window.location.href = url.toString();
      });
    });

    // Mobile sort radio buttons
    $$('[data-sort-radio]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        var base = radio.getAttribute('data-sort-base');
        var url = new URL(base || window.location.href, window.location.origin);
        if (radio.value) url.searchParams.set('sort_by', radio.value);
        else url.searchParams.delete('sort_by');
        window.location.href = url.toString();
      });
    });

    // Mobile sort modal toggle
    var sortModal = $('#SortModal');
    $$('.js-toggle-sort').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (sortModal) sortModal.classList.toggle('is-open');
      });
    });
  }

  /* ---------- PLP load more ---------- */
  function initLoadMore() {
    var btn = $('.js-load-more');
    var grid = $('[data-plp-grid]');
    if (!btn || !grid) return;
    btn.addEventListener('click', function () {
      var nextUrl = btn.getAttribute('data-next-url');
      if (!nextUrl) return;
      btn.disabled = true;
      btn.textContent = 'Loading…';
      fetch(nextUrl)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var freshGrid = doc.querySelector('[data-plp-grid]');
          if (freshGrid) {
            Array.prototype.forEach.call(freshGrid.children, function (card) {
              grid.appendChild(document.importNode(card, true));
            });
          }
          var freshBtn = doc.querySelector('.js-load-more');
          if (freshBtn && freshBtn.getAttribute('data-next-url')) {
            btn.setAttribute('data-next-url', freshBtn.getAttribute('data-next-url'));
            btn.disabled = false;
            btn.textContent = freshBtn.textContent.trim();
          } else {
            var wrap = btn.parentElement;
            wrap.style.display = 'none';
          }
        })
        .catch(function () { window.location.href = nextUrl; });
    });
  }

  /* ---------- Init on DOM ready & after section reload in editor ---------- */
  function init() {
    initMobileNav();
    initSearch();
    initHeroSliders();
    initCartDrawer();
    initAddToCartForms();
    initQuantitySteppers();
    initProductGallery();
    initVariantPicker();
    initFacets();
    initSort();
    initLoadMore();
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();

/* ============ Wishlist Logic ============ */
var Wishlist = {
  key: 'souled_wishlist',
  init: function () {
    this.handles = JSON.parse(localStorage.getItem(this.key)) || [];
    this.bindButtons();
    if (window.location.pathname.includes('/pages/wishlist')) {
      this.renderWishlist();
    }
  },
  save: function () {
    localStorage.setItem(this.key, JSON.stringify(this.handles));
  },
  add: function (handle) {
    if (!this.handles.includes(handle)) {
      this.handles.push(handle);
      this.save();
    }
  },
  remove: function (handle) {
    this.handles = this.handles.filter(function (h) { return h !== handle; });
    this.save();
  },
  toggle: function (handle) {
    if (this.handles.includes(handle)) {
      this.remove(handle);
      return false;
    } else {
      this.add(handle);
      return true;
    }
  },
  bindButtons: function () {
    var self = this;
    var btns = document.querySelectorAll('.js-wishlist-toggle');
    btns.forEach(function (btn) {
      var handle = btn.getAttribute('data-handle');
      if (!handle) return;

      if (self.handles.includes(handle)) {
        btn.classList.add('is-active');
        btn.innerHTML = btn.innerHTML.replace('Wishlist', 'Wishlisted');
      }

      // Prevent double binding
      if (btn.dataset.wishlistBound) return;
      btn.dataset.wishlistBound = 'true';

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var isActive = self.toggle(handle);
        if (isActive) {
          btn.classList.add('is-active');
          btn.innerHTML = btn.innerHTML.replace('Wishlist', 'Wishlisted');
        } else {
          btn.classList.remove('is-active');
          btn.innerHTML = btn.innerHTML.replace('Wishlisted', 'Wishlist');

          if (window.location.pathname.includes('/pages/wishlist')) {
            var card = btn.closest('.card-product');
            if (card) card.remove();
            if (self.handles.length === 0) {
              var empty = document.querySelector('.wishlist-empty');
              if (empty) empty.style.display = 'block';
            }
          }
        }
      });
    });
  },
  renderWishlist: function () {
    var grid = document.querySelector('.wishlist-grid');
    var empty = document.querySelector('.wishlist-empty');
    if (!grid) return;

    if (this.handles.length === 0) {
      grid.innerHTML = '';
      if (empty) empty.style.display = 'block';
      return;
    }

    if (empty) empty.style.display = 'none';
    grid.innerHTML = '<p style="text-align:center; width:100%; grid-column: 1/-1;">Loading your wishlist...</p>';

    var query = this.handles.map(function (h) { return 'handle:' + h; }).join(' OR ');
    fetch('/search?view=wishlist-results&type=product&q=' + encodeURIComponent(query))
      .then(function (res) { return res.text(); })
      .then(function (html) {
        grid.innerHTML = html;
        Wishlist.bindButtons();
      })
      .catch(function (err) {
        grid.innerHTML = '<p style="text-align:center; width:100%; grid-column: 1/-1;">Failed to load wishlist.</p>';
      });
  }
};

document.addEventListener('DOMContentLoaded', function () {
  Wishlist.init();
});
